<template>
    <div class="wrap-layout">
        <div class="layout">
            <div class="wrap-sidebar" :class="{ 'hide-side': status }" :miniSide="status">
                <Sidebar v-show="role == 3 || role == 2 || role == 3 || role == 7" />
                <SidebarOperator v-show="role == 5" />
                <SidebarJfx v-show="role == 15" />
                <sidebar-pos v-show="role == 6 " />
                <sidebar-super-admin v-show="role == 99" />
                <sidebar-bappebti v-show="role == 8 || role == 9"></sidebar-bappebti>
            </div>
            <div class="wrap-main-content" :class="{ 'mini-side': status }">
                <header class="header">
                    <Header @toggleSide="openToggle" />
                </header>
                <main>
                    <router-view></router-view>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from "../components/utilsLayout/Sidebar.vue";
import SidebarOperator from "../components/utilsLayout/SidebarOperator.vue";
import SidebarJfx from "../components/utilsLayout/SidebarJfx.vue";
import Header from "../components/utilsLayout/Header.vue";
import SidebarSuperAdmin from "../components/utilsLayout/SidebarSuperAdmin.vue";
import SidebarPos from "../components/utilsLayout/SidebarPos.vue";
import SidebarBappebti from "../components/utilsLayout/SidebarBappebti.vue";

export default {
    components: {
        Sidebar,
        Header,
        SidebarOperator,
        SidebarJfx,
        SidebarSuperAdmin,
        SidebarPos,
        SidebarBappebti,
    },
    data() {
        return {
            status: false,
            role: "",
        };
    },
    mounted() {
        this.role = sessionStorage.getItem("role");
    },
    methods: {
        openToggle(e) {
            this.status = e;
        },
    },
};
</script>
<style scoped>
.wrap-layout {
    min-height: 100vh;
}
.layout {
    height: 100%;
    display: flex;
    position: relative;
}

.header {
    height: 70px;
    padding: 5px 40px;
    background: #fff;
    color: #2c3e50;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.11);
    position: fixed;
    width: calc(100% - 80px);
    z-index: 9;
    line-height: 57px;
}

.wrap-sidebar {
    height: 100%;
    width: 80px;
    background: #0d1d2c;
    color: #9ea5ab;
    position: fixed;
    transition: ease-out 0.5s;
    z-index: 1;
}

.hide-side {
    width: 240px;
}

.wrap-main-content {
    margin-left: 80px;
    transition: ease-out 0.5s;
    width: calc(100% - 80px);
}

.mini-side {
    margin-left: 240px;
}

.mini-side .header {
    width: calc(100% - 240px);
}

/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #0d1d2c;
    display: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #fff;
    border-radius: 50px;
    display: none;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
    border-radius: 50px;
}

main {
    margin-top: 70px;
}

@media only screen and (max-width: 600px) {
    .wrap-sidebar {
        margin-left: -240px;
    }
    .wrap-main-content {
        margin-left: 0;
    }
    .hide-side {
        margin-left: 0;
        width: 240px;
        z-index: 1;
    }
}
</style>
